export default {
  // 分页查询
  QUERY_PDPERIOD_PAGE: '/produce/pdPeriod/queryPdPeriodPage',
  // 保存
  SAVE_PDPERIOD: '/produce/pdPeriod/savePdPeriodList',
  // 删除
  DELETE_PDPERIOD: '/produce/pdPeriod/deletePdPeriodList',
  // 打开期间
  OPEN_PDPERIOD: '/produce/pdPeriod/open',
  // 关闭期间
  CLOSE_PDPERIOD: '/produce/pdPeriod/close',
  //获取账期名称
  GET_PDPERIOD_NAME: '/produce/pdPeriod/getSerialNumber',
};
